import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Modal, Button, Form } from "react-bootstrap";

import ResultModalText from "../resultModalText/resultModalText";
import LoaderWithOverlay from "../../../GeneralComponents/loaderWithOverlay/loaderWithOverlay";

import { sendSignStringError } from "../../../../redux/RegistrationChangesInformationRHFReducer/actionsRegistrationChangesInformationRHF";

import { ReactComponent as EyeOff } from "../../../../resourсes/eye-off.svg";
import { ReactComponent as Eye } from "../../../../resourсes/eye.svg";

import { STATUS_INFO_BY_PERSONAL_NUM } from "../../../../redux/types";

import styles from "./passwordModal.module.css";

const PasswordModal = ({ show, handleClose, handleSave }) => {
  const dispatch = useDispatch();

  const sendSignStringErrorText = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.sendSignStringError,
  );
  const userByPersonalNumStatus = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.userByPersonalNumStatus,
  );
  const userByPersonalNumError = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.userByPersonalNumError,
  );

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordErrorModal, setShowPasswordErrorModal] = useState(false);
  const [errorText, setErrorText] = useState("");

  const onSave = () => {
    handleSave(password);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleClosePasswordErrorModal = () => {
    dispatch(sendSignStringError(null));
    setShowPasswordErrorModal(false);
    dispatch({
      type: STATUS_INFO_BY_PERSONAL_NUM,
    });
  };

  useEffect(() => {
    if (sendSignStringErrorText) {
      setShowPasswordErrorModal(true);
      setErrorText(sendSignStringErrorText);
    }
  }, [sendSignStringErrorText]);

  useEffect(() => {
    if (userByPersonalNumStatus === "success") {
      handleClose();
      dispatch({
        type: STATUS_INFO_BY_PERSONAL_NUM,
      });
    }

    if (userByPersonalNumStatus === "error") {
      setErrorText(userByPersonalNumError);
      setShowPasswordErrorModal(true);
    }
  }, [userByPersonalNumStatus]);

  if (userByPersonalNumStatus === "loading") {
    return (
      <LoaderWithOverlay isLoading={userByPersonalNumStatus === "loading"} />
    );
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className={styles["form-header"]} closeButton>
          <Modal.Title className={styles["form-title"]}>
            Введите пароль
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles["form-body"]}>
          <Form>
            <Form.Group
              className={styles["form-data"]}
              controlId="formPasswordAgent"
            >
              <Form.Label>Пароль</Form.Label>
              <div className={styles["form"]}>
                <Form.Control
                  className={styles["form-input"]}
                  type={showPassword ? "text" : "password"}
                  placeholder="Введите пароль"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className={`${styles["form-input-password"]}`}
                >
                  {showPassword ? <EyeOff /> : <Eye />}
                </button>
              </div>
            </Form.Group>
            <div className={styles["form-footer"]}>
              <Button
                className={styles["save-btn"]}
                variant="primary"
                onClick={onSave}
              >
                Найти
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <ResultModalText
        headerName={" "}
        show={showPasswordErrorModal}
        handleClose={handleClosePasswordErrorModal}
        text={errorText}
      />
    </>
  );
};

export default PasswordModal;
